import React, { FC } from "react";
import { TableProps, Table } from "antd";

import { IServiceItem } from 'types/recommendations.types';
import { ICity } from 'types/dictionaries.types';

type Props<T> = Pick<TableProps<T>, 'onChange' | 'rowSelection' | 'rowKey' | 'pagination'> & {
  items: IServiceItem[];
  loading: boolean;
}

export const RecommendationsTable: FC<Props<IServiceItem>> = ({
  onChange,
  rowSelection,
  rowKey,
  items,
  pagination,
  loading
}) => {
  return (
    <Table
      rowKey={rowKey}
      loading={loading}
      dataSource={items}
      pagination={pagination}
      onChange={onChange}
      rowSelection={rowSelection}
      columns={[
        {
          dataIndex: 'code',
          title: 'Код',
          align: 'center',
        },
        {
          dataIndex: 'name',
          title: 'Наименование',
          align: 'center',
        },
        {
          dataIndex: 'city',
          title: 'Город',
          align: 'center',
          render: (val: ICity) => val?.name,
        },
      ]}
    />
  );
};